import * as React from 'react';

export abstract class ScreenComponent<P, S> extends React.Component<P, S> {
	public componentDidMount() {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}
}
